var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['cart-inner']},[_c('ProductsTable',{attrs:{"delete-func":_vm.handleRemoveFromCart,"update-func":_vm.handleUpdateCartQuantity,"products":_vm.cartProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }